var Flickity = require('flickity');

const testimoniesCarousels = document.querySelectorAll('.js-testimonies');

testimoniesCarousels.forEach((elem) => {
  new Flickity( elem, {
    adaptiveHeight: false,
    autoPlay: 7000,
    prevNextButtons: false,
  });
})
